import React from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import DeleteAdjustmentForm from './deleteExceptionAdjustmentForm';
import { getAdjustmentApi } from '../../utils/apisConsts';
const deleteExceptionAdjustment = () => {
    const componentSteps = [
        {
        title: 'Exception Adjustment ID',
        content: <GetInfo isAdjustment placeHolder="Enter Adjustment ID" apiLink={getAdjustmentApi}/>,
        id: 0,
        }, {
        title: 'Delete Exception adjustment',
        content: <DeleteAdjustmentForm />,
        id: 1
        },
    ];
    
  return (
    <div className='delete-exception-adjustment'>
        <Stepper componentSteps={componentSteps} />
    </div>
    
  )
}

export default deleteExceptionAdjustment